var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.112 .5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#56B924"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 4,
    d: "M4.896 11.518l5.57 5.666L17.772 5.62"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC4xMTIgLjUpIj4KICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEyIiBmaWxsPSIjNTZCOTI0Ii8+CiAgICA8cG9seWxpbmUgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjQiIHBvaW50cz0iNC44OTYgMTEuNTE4IDEwLjQ2NiAxNy4xODQgMTcuNzcyIDUuNjIiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconGreenCheck as ReactComponent };